import React from 'react';

import { Color, EnumTag } from '../../../components/EnumTag';

interface IFunnelAppointmentStatusProps {
  status: string | null | undefined;
}

export const FunnelAppointmentStatus: React.FC<IFunnelAppointmentStatusProps> = ({ status }) => {
  if (!status) {
    return <></>;
  }

  return (
    <EnumTag
      style={{ textTransform: 'uppercase' }}
      enumValue={status}
      colorMap={{
        Cancelled: Color.Red,
        Confirmed: Color.Blue,
        Completed: Color.Green,
        'No Show': Color.Red,
      }}
    />
  )
};
